// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ScheduleTwoToneSvg from "@ant-design/icons-svg/es/asn/ScheduleTwoTone";
import AntdIcon from '../components/AntdIcon';

var ScheduleTwoTone = function ScheduleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleTwoToneSvg
  }));
};

ScheduleTwoTone.displayName = 'ScheduleTwoTone';
export default React.forwardRef(ScheduleTwoTone);